// components/PageLoader.js
// ONE shared loading screen for the whole app.
//
// Used both as the Suspense fallback while a page's code downloads (App.js)
// AND as the page's own "loading data" state (AdminDashboard, Profile,
// EmailTemplatePage). Because both render the identical layout at the
// identical position, going from "downloading the page" to "page loading its
// data" no longer shows two different spinners one after the other — only
// the text under the spinner changes.
import React from 'react';

export default function PageLoader({ fullScreen = false, label = '' }) {
  return (
    <div
      style={{
        minHeight: fullScreen ? '100vh' : 'calc(100vh - 90px)',
        background: fullScreen ? '#fcf0ee' : 'transparent',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14,
        padding: 16,
      }}
      role="status"
      aria-live="polite"
    >
      <img src="/logo_360.png" alt="" width="72" height="72"
        style={{ width: 72, height: 72, objectFit: 'contain' }} />
      <div style={{
        width: 28, height: 28, borderRadius: '50%',
        border: '3px solid rgba(249,115,22,.2)', borderTopColor: '#f97316',
        animation: 'pageLoaderSpin .8s linear infinite',
      }} />
      {/* Always reserve the text line so the spinner never jumps when a label appears */}
      <div style={{ fontSize: 13, color: '#6b7280', minHeight: 18 }}>{label || ' '}</div>
      <style>{'@keyframes pageLoaderSpin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}
